const generateSummaryOfFindingsNarrative = (resource) => {
    let innerDiv = "";
    try {
        if (resource.section?.[0]?.code?.coding?.[0]?.code === "column-headers" &&
            resource.section[0].section?.length > 0 &&
            resource.section[1]?.code?.coding?.[0]?.code === "summary-of-findings" &&
            resource.section[1].section?.length > 0) {
            innerDiv += "<table><tr>";
            for (const columnHeader of resource.section[0].section) {
                let headerValue = columnHeader?.text?.div;
                let header = headerValue.replace('<div xmlns="http://www.w3.org/1999/xhtml">', '')
                    .replace('<div xmlns="http://www.w3.org/1999/xhtml">', '')
                    .replace('<p>', '').replace('</p>', '').replace('</div>', '');
                innerDiv += "<th>" + header + "</th>";
            }
            innerDiv += "</tr>";
            for (const result of resource.section[1].section) {
                innerDiv += "<tr>";
                for (const cell of result.section) {
                    innerDiv += "<td>";
                    let cellValueDiv = cell?.text?.div;
                    let cellValue = cellValueDiv.replace('<div xmlns="http://www.w3.org/1999/xhtml">', '')
                        .replace('<div xmlns="http://www.w3.org/1999/xhtml">', '')
                        .replace('<p>', '').replace('</p>', '').replace('</div>', '');
                    innerDiv += cellValue;
                    innerDiv += "</td>";
                }
                innerDiv += "</tr>";
            }
            innerDiv += "</table><br/>";
        }
    } catch {
        innerDiv = "[Unable to generate Narrative Summary.]"
    }
    return {
        "status": "generated",
        "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + innerDiv + "</div>"
    };
}

export default generateSummaryOfFindingsNarrative;